import React, { useMemo } from 'react';
import { Typography } from '@mui/material';

import styles from './ProbabilityCell.module.scss';

type Props = {
  loading: boolean;
  probability: number | null | undefined;
};

const ProbabilityCell: React.FC<Props> = ({ probability, loading }) => {
  const loadingOrError = useMemo(
    () => (!probability && probability !== 0) || loading,
    [probability, loading],
  );

  const roundedProbability = useMemo(() => Math.round((probability || 0) / 5) * 5, [probability]);

  return (
    <div className={styles.wrapper} data-testid="forecast-table-probability-cell">
      {loadingOrError ? (
        <div data-testid="forecast-table-probability-empty-content" className={styles.emptyContent}>
          <Typography
            className={styles.percent}
            color="text.light"
            component="p"
            data-testid="forecast-table-probability-empty"
            variant="caption1"
          >
            --%
          </Typography>
        </div>
      ) : (
        <Typography
          className={styles.content}
          component="span"
          data-testid="forecast-table-probability-content"
        >
          <Typography
            className={styles.probability}
            color="text.primary"
            component="h3"
            data-testid="forecast-table-probability"
            variant="subHeadline"
          >
            {roundedProbability}
          </Typography>
          <Typography
            className={styles.percent}
            color="text.primary"
            component="p"
            data-testid="forecast-table-probability-percent"
            variant="caption1"
          >
            %
          </Typography>
        </Typography>
      )}
    </div>
  );
};

export default ProbabilityCell;
